module.exports = __webpack_public_path__ + "img/diagram_13_1.c3e26910.png";